import { Grid, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import GuideComponent from "../../../components/materialui/Shared/GuideComponent"
import GuideIMG from "../../../../assets/guide.png";


const useStyles = makeStyles(() => ({

    message: {
        fontSize: '1em',
        color: '#000',
        fontWeight: 'lighter',
    },

    documentItem: {
        fontSize: '0.8em',
        color: '#231F20',
        font: 'Inter',
        fontWeight: 'lighter',
    },

    image: {
        width: '40%',
        display: "block",
        margin: "0 auto"
    },
}));


export default function GuideStep() {

    const classes = useStyles();

    return (
        <div>
            <GuideComponent title="Guia de documentação">
                <Grid container spacing={2}>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item sm={12}>
                                <img src={GuideIMG} className={classes.image} alt="Imagem ilustrativa" />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.message}>
                            Antes de iniciar o preenchimento do formulário, tenha em mãos os seguintes documentos que deverão ser anexados a solicitação:
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.message}>
                            Corpo Clínico Aberto
                        </Typography>
                        <Typography variant="body2" component="span" className={classes.documentItem}>
                            <p> - Atestado de capacidade física e cognitiva; </p>
                            <p> - Carteira de Vacinação atualizada ou termo em anexo;  </p>
                            <p> - Carteira do Conselho (CRM / CRO);  </p>
                            <p> - Certidão de Ética Profissional (emitida pelo site do CREMESP); </p>
                            <p> - Certidão de Quitação (emitida pelo site do CREMESP);  </p>
                            <p> - Certificados do curso de reanimação (Obrigatório apenas para médico Anestesista); </p>
                            <p> - Comprovante de Vacinação COVID19; </p>
                            <p> - Currículo resumido atualizado; </p>
                            <p> - Diploma Graduação em Medicina <strong> (Frente e Verso); </strong>  </p>
                            <p> - Foto fundo branco; </p>
                            <p> - Nome de 5 médicos <strong> com 5 anos de atuação no Corpo Clínico do hospital </strong>,
                                sendo que <strong> pelo menos três exerçam atividade profissional semelhante à solicitada pelo interessado. </strong></p>
                            <p> - RG; </p>
                            <p> - Registro de Qualificação de Especialista (RQE); </p>
                            <p> - Título de Especialista ou Residência Médica <strong> (Frente e Verso) </strong> - (Mínimo 2 anos da data de conclusão);</p>
                        </Typography>
                    </Grid>

                </Grid>
            </GuideComponent>
        </div>

    )
}